import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I am a professional Web Developer proficient in HTML, CSS and Javascript. Having strong fundamentals and high work ethic allows me to constantly create more appealing and innovative designs, build and enhance existing systems and implement the best practice procedures in all areas of work.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      